/**
 * Aimbotpads "Find Your Pad" quiz widget.
 *
 * Embed on any page (e.g. a "Quiz" page in Shopify, or the homepage):
 *
 *   <div id="pad-quiz"></div>
 *   <script src="{{ 'pad-quiz.js' | asset_url }}" defer></script>
 *
 * Edit PRODUCTS below to match your real product handles/URLs/images.
 * Edit QUESTIONS to change what's asked â€” each answer nudges a score
 * toward one or more products via `weights`.
 */
(function () {
  const PRODUCTS = {
    control: {
      name: "Control",
      tagline: "High-friction surface for pinpoint tracking and tactical aim.",
      url: "/products/control",
      price: "$40",
    },
    balance: {
      name: "Balance",
      tagline: "Middle-ground glide and stopping power good for hybrid playstyles.",
      url: "/products/balance",
      price: "$40",
    },
    speed: {
      name: "Speed",
      tagline: "Low-friction surface for fast flicks and wide swipes.",
      url: "/products/speed",
      price: "$40",
    },
  };

  const QUESTIONS = [
    {
      id: "genre",
      prompt: "What do you mainly play?",
      answers: [
        { label: "Tactical shooters (Valorant, CS2)", weights: { control: 2 } },
        { label: "Fast-paced FPS (Apex, Overwatch)", weights: { speed: 2 } },
        { label: "MOBA / RTS / mixed genres", weights: { balance: 2 } },
      ],
    },
    {
      id: "sensitivity",
      prompt: "What's your mouse sensitivity like?",
      answers: [
        { label: "Low sens, big arm movements", weights: { speed: 1, balance: 1 } },
        { label: "Medium sens", weights: { balance: 2 } },
        { label: "High sens, mostly wrist flicks", weights: { control: 2 } },
      ],
    },
    {
      id: "grip",
      prompt: "How do you grip your mouse?",
      answers: [
        { label: "Palm grip", weights: { control: 1, balance: 1 } },
        { label: "Claw grip", weights: { balance: 2 } },
        { label: "Fingertip grip", weights: { speed: 2 } },
      ],
    },
    {
      id: "priority",
      prompt: "What matters most to you in a pad?",
      answers: [
        { label: "Precise stops and micro-adjustments", weights: { control: 2 } },
        { label: "Fast glide with minimal resistance", weights: { speed: 2 } },
        { label: "Consistency across different games", weights: { balance: 2 } },
      ],
    },
  ];

  const mount = document.getElementById("pad-quiz");
  if (!mount) {
    console.error("Pad quiz: no #pad-quiz element found on this page.");
    return;
  }

  let current = 0;
  const scores = { control: 0, balance: 0, speed: 0 };

  function renderQuestion() {
    const q = QUESTIONS[current];
    mount.innerHTML = `
      <div class="pq-card">
        <div class="pq-progress">Question ${current + 1} of ${QUESTIONS.length}</div>
        <h3 class="pq-prompt">${q.prompt}</h3>
        <div class="pq-answers">
          ${q.answers
            .map(
              (a, i) => `<button class="pq-answer-btn" data-index="${i}">${a.label}</button>`
            )
            .join("")}
        </div>
      </div>
    `;

    mount.querySelectorAll(".pq-answer-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const answer = q.answers[Number(btn.dataset.index)];
        Object.entries(answer.weights).forEach(([key, val]) => {
          scores[key] += val;
        });
        current++;
        current < QUESTIONS.length ? renderQuestion() : renderResult();
      });
    });
  }

  function renderResult() {
    const winnerKey = Object.entries(scores).sort((a, b) => b[1] - a[1])[0][0];
    const product = PRODUCTS[winnerKey];

    mount.innerHTML = `
      <div class="pq-card pq-result">
        <div class="pq-result-label">Your match:</div>
        <h3 class="pq-result-name">${product.name}</h3>
        <p class="pq-result-tagline">${product.tagline}</p>
        <a class="pq-cta" href="${product.url}">Shop ${product.name}  ${product.price}</a>
        <button class="pq-retake" id="pq-retake-btn">Retake quiz</button>
      </div>
    `;

    document.getElementById("pq-retake-btn").addEventListener("click", () => {
      current = 0;
      scores.control = 0;
      scores.balance = 0;
      scores.speed = 0;
      renderQuestion();
    });
  }

  renderQuestion();
})();